import { ErrorMessage, Field } from "formik";

const FloatingInput = ({
  label,
  name,
  type,
  css,
  maxLength,
  keyId,
  disabled = false,
  as,
  value, // optional manual value
}) => {
  const isControlled = value !== undefined;

  return (
    <div className={`relative mb-1 ${css}`} key={keyId}>
      {isControlled ? (
        <input
          type={type}
          name={name}
          id={name}
          value={value}
          as={as}
          maxLength={maxLength || ""}
          autoComplete="new-password"
          rows={as === "textarea" ? 4 : undefined}
          cols={as === "textarea" ? 50 : undefined}
          className={`block border rounded-md px-2.5 pb-2.5 pt-5 w-full text-sm appearance-none peer
            ${disabled
              ? "bg-gray-100 text-gray-600 border-gray-200 cursor-not-allowed"
              : "bg-white text-secondary border-gray-300 focus:outline-none focus:ring-0 focus:border-secondary"
            }`}
          placeholder=" "
          disabled={disabled}
        />
      ) : (
        <Field
          type={type}
          name={name}
          id={name}
          required
          as={as}
          maxLength={maxLength || ""}
          autoComplete="new-password"
          rows={as === "textarea" ? 4 : undefined}
          cols={as === "textarea" ? 50 : undefined}
          className={`block border rounded-md px-2.5 pb-2.5 pt-5 w-full text-sm appearance-none peer
            ${disabled
              ? "bg-gray-100 text-gray-600 border-gray-200 cursor-not-allowed"
              : "bg-white text-secondary border-gray-300 focus:outline-none focus:ring-0 focus:border-secondary"
            }`}
          placeholder=" "
          disabled={disabled}
        />
      )}

      <label
        htmlFor={name}
        className={`${as === "textarea" ? "w-full mt-[-2px]" : "z-10"
   } pl-2.5 absolute text-sm text-secondary duration-300 transform -translate-y-4 scale-75 top-4 origin-[0] start-2.5 peer-focus:text-secodnary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}
      >
        {label}
      </label>

      <ErrorMessage
        name={name}
        component="div"
        className="text-red-500 text-[10px] absolute right-0"
      />
    </div>
  );
};

export default FloatingInput;
